import { FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { validateUpercase } from '@app/validators/must-have-upercase.directive';
import { validateLowercase } from '@app/validators/must-have-lowercase.directive';
import { validateHasNumber } from '@app/validators/must-have-number.directive';
import { validateHasSpecialCharacters } from '@app/validators/must-contain-characters.directive';

export interface CognitoPasswordPolicy {
  MinimumLength?: number;
  RequireUppercase?: boolean;
  RequireLowercase?: boolean;
  RequireNumbers?: boolean;
  RequireSymbols?: boolean;
}

export const COGNITO_SPECIAL_CHARACTER_REGEX =
  '[\\^ $ * . [ \\] { } ( ) ? \\- " ! @ # % & / \\\\ , > < \' : ; | _ ~ `]';

export function getNewPwValidatorsFromPolicy(
  policy: CognitoPasswordPolicy | null | undefined
): ValidatorFn[] {
  if (!policy) return [];
  const minLength = policy.MinimumLength ?? 0;
  const validators: ValidatorFn[] = [
    Validators.required,
    Validators.minLength(minLength),
  ];
  if (policy.RequireUppercase) validators.push(validateUpercase);
  if (policy.RequireLowercase) validators.push(validateLowercase);
  if (policy.RequireNumbers) validators.push(validateHasNumber);
  if (policy.RequireSymbols)
    validators.push(validateHasSpecialCharacters(COGNITO_SPECIAL_CHARACTER_REGEX));
  return validators;
}

export function addConfirmPwRevalidation(
  form: FormGroup,
  newPwControlName: string = 'newPw',
  confirmPwControlName: string = 'confirmPw',
  destroyNotifier?: Observable<unknown>
): Subscription | null {
  const newPw = form.get(newPwControlName);
  const confirmPw = form.get(confirmPwControlName);
  if (!newPw || !confirmPw) {
    return null;
  }
  const updates$ = newPw.valueChanges.pipe(
    tap(() => confirmPw.updateValueAndValidity())
  );
  if (destroyNotifier) {
    return updates$.pipe(takeUntil(destroyNotifier)).subscribe();
  }
  return updates$.subscribe();
}
